<template>
  <popper
    class="mr-1 mb-1"
    trigger="clickToToggle"
    :options="{
      placement: 'bottom',
      modifiers: { offset: { offset: '0,10' } },
    }"
  >
    <div
      class="popper"
      :data-test-id="`tinyurl_${prefix}_qrcode_section`"
    >
      <QR
        class="py-2 px-3"
        :qr-test-id="`tinyurl_${prefix}_qrcode_img`"
        :url="url"
      />
    </div>

    <button
      slot="reference"
      v-tooltip="{
        content: 'QR Code',
        placement: 'bottom',
        trigger: isOnMobile ? 'click' : 'focus hover',
      }"
      :class="['btn btn-blue h-100', size ? `btn-${size}` : ``]"
      :data-test-id="`tinyurl_${prefix}_qrcode_dropdown_btn`"
      aria-label="QR Code"
    >
      <i class="fa fa-fw fa-qrcode" />
      <span class="d-none d-sm-inline ml-1">QR</span>
    </button>
  </popper>
</template>

<script>
import { mapGetters } from "vuex";
import Popper from "vue-popperjs";
import QR from "@Components/sharing/QR.vue";

export default {
  name: "QRDropdown",

  components: { Popper, QR },

  props: {
    prefix: {
      type: String,
      required: true,
    },

    size: {
      type: String,
      default: "",
    },

    url: {
      type: String,
      default: "",
    },
  },

  computed: {
    ...mapGetters(["isOnMobile"]),
  },
};
</script>
